import { IonContent, IonPage } from '@ionic/react';

import logo from '@/assets/images/logo/logo-with-icon.png';
import { Padding, Promo } from '@/components/common';
import { Text } from '@/components/memo';

import './Maintenance.css';

const Maintenance: React.FC = () => {
  const copy = {
    promo: {
      header: (
        <>
          We'll be <Text color="primary">back</Text> soon!
        </>
      ),
      subHeader: "We're working on making your experience even more awesome!"
    }
  };

  return (
    <IonPage id="maintenance">
      <IonContent scrollX={false} scrollY={false}>
        <Padding>
          <div className="maintenance__promo-container">
            <Promo
              image={logo}
              imageStyle={{ maxWidth: 192 }}
              header={copy.promo.header}
              subHeader={copy.promo.subHeader}
            />
          </div>
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Maintenance;
